import React, { MouseEvent } from 'react';
import classes from './ListItem.module.scss';
import { Void } from '../../../models/basic-objects';
import { IconsEnum } from '../../../constants/icons';
import { Icon } from '../../images/Icon/Icon';
import classNames from 'classnames';
import { WithChildren } from '../../../models/children-props';
import useWhatInput from 'react-use-what-input';
import { WhatInputType } from 'what-input';

export type ContainerListItem = {
  action: Void;
  label: string;
  disabled?: boolean;
};

export type ListItemViewProps = WithChildren & {
  //
  action: (e?: MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void;
  disabled: boolean;
  icon?: IconsEnum;
  listItemLinkType?: 'a' | 'button';
  selected: boolean;
  type: 'li' | 'div';
  variation: 'dark' | 'regular';
  unsetWidth?: boolean;
  expanded?: boolean;
};

export const ListItemView = (props: ListItemViewProps): JSX.Element => {
  const intentType: WhatInputType = useWhatInput('intent');
  const ItemTag = `${props.type}` as keyof Pick<JSX.IntrinsicElements, 'li' | 'div'>;
  const LinkType = (props.listItemLinkType ? `${props.listItemLinkType}` : 'a') as keyof Pick<
    JSX.IntrinsicElements,
    'a' | 'button'
  >;

  const mainClasses = classNames(classes.ListItem, {
    [classes.ListItemUnsetWidth]: props.unsetWidth,
    [classes.ListItemExpanded]: props.expanded
  });
  const hrefClasses = classNames(classes.ListItemHref, {
    [classes.ListItemHrefRegularSelected]: props.selected && props.variation !== 'dark',
    [classes.ListItemHrefSettingsSelected]: props.selected && props.variation === 'dark',
    [classes.ListItemHrefTouch]: intentType === 'touch',
    [classes.ListItemHrefDisabled]: props.disabled,
    [classes.ListItemHrefSettings]: props.variation === 'dark',
    [classes.ListItemHrefRegular]: props.variation !== 'dark'
  });

  const svgClass = classNames(classes.SvgWrapper, {
    [classes.SvgWrapperRegularSelected]: props.selected && props.variation !== 'dark',
    [classes.SvgWrapperSettingsSelected]: props.selected && props.variation === 'dark'
  });
  const labelTextClasses = classNames(classes.LabelText, {
    [classes.LabelTextRegularSelected]: props.selected && props.variation !== 'dark'
  });

  const labelWrapperClasses = classNames(classes.LabelWrapper, 'grid-x', {
    'cell auto': props.icon
  });

  const label = props.icon ? (
    <>
      <div className={'cell shrink'}>
        <div className={svgClass}>
          <Icon name={props.icon} size={'medium'} />
        </div>
      </div>
      <div className={'cell auto'}>
        <div className={labelTextClasses}>{props.children}</div>
      </div>
    </>
  ) : (
    <div className={labelTextClasses}>{props.children}</div>
  );
  return (
    <ItemTag
      className={mainClasses}
      {...(props.type === 'div' ? { role: 'list-item' } : {})}
      {...(props.selected ? { 'data-selected': true } : {})}
      {...(props.disabled
        ? {
            onClick: () => {
              // we added an empty on click handler since we might use target to check against onClick prop !== null that will prevent propagation without using e.stropPropagation
            }
          }
        : {})}>
      <LinkType onClick={e => props.action(e)} className={hrefClasses}>
        <div className={labelWrapperClasses}>{label}</div>
      </LinkType>
    </ItemTag>
  );
};
